import Api from "../../../services/api";

export function loadForm(params, cb) {
    return (dispatch) => {
        Api.put('/w05f1424/load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function deleteRow(params, cb) {
    return (dispatch) => {
        Api.delete('/w05f1424/delete', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function save(params, cb) {
    return (dispatch) => {
        Api.put('/w05f1424/save', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}
